import React from 'react';
import { Icon } from '../../../SvgIcon';

interface Props {
  width?: number;
  height?: number;
}

export const Weibo = (props: Props) => {
  const { width = 20, height = 20 } = props;
  return <Icon name="weibo" width={width} height={height} />;
};
